import {ReducerBuilder} from "@cuatroochenta/co-redux-builders";
import ChatBroadcast from "../../../../../commons/model/ChatBroadcast";
import TaskChatBroadcastList from "../../../../../commons/ws/chat/TaskChatBroadcastList";
import {PagerBackendProps} from "../../../../../components/Pager";

interface InitialState {
    loading: boolean,
    broadcastList: ChatBroadcast[],
    error: string,
    pager: PagerBackendProps,
}

const INITIAL_STATE: InitialState = {
    loading: false,
    broadcastList: [],
    error: '',
    pager: {
        current: 1,
        total_pages: 1,
        total_elements: 0,
    },
};

export default ReducerBuilder.newBuilder(INITIAL_STATE)

    .onEvent(TaskChatBroadcastList.REDUX_ACTION_OBJECT_ON_PRE_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: true}
    })
    .onEvent(TaskChatBroadcastList.REDUX_ACTION_OBJECT_ON_POST_EXECUTE, (oldState, payload) => {
        return {...oldState, loading: false}
    })
    .onEvent(TaskChatBroadcastList.REDUX_ACTION_OBJECT_ON_FAIL, (oldState, payload) => {
        return {...oldState, error: payload}
    })
    .onEvent(TaskChatBroadcastList.REDUX_ACTION_OBJECT_ON_SUCCESS, (oldState, payload) => {
        return {
            ...oldState,
            broadcastList: payload.data,
            pager: payload.pager || oldState.pager
        }
    })

    .build()
